// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
// import whyFederalRegulation from './routes/whyFederalRegulation';
import landing from './routes/landing';

// import font awesome
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faInstagram, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faArrowRight, faUserCircle, faBars, faWindowClose } from '@fortawesome/free-solid-svg-icons';
library.add(faFacebookF, faInstagram, faXTwitter, faYoutube, faArrowRight, faUserCircle, faBars, faWindowClose);
dom.watch();

//AOS
import AOS from 'aos';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Why Regulation
  // whyFederalRegulation,
  //Landing
  landing,
});


// Load Events
jQuery(document).ready(() => {

  routes.loadEvents();

  AOS.init({
    duration: 1000,
    once: true,
    disable: 'mobile',
  });

  jQuery( 'header#header li.menu-item-has-children' ).each(function( index ) {
    console.log(index);
    $(this).find('a:first').removeAttr('href');
  });


  $('#pdf-slider .content').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:'<div class="slick-prev"><i class="far fa-arrow-left"></i></div>',
    nextArrow:'<div class="slick-next"><i class="far fa-arrow-right"></i></div>',
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 996,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

});



// WEBPACK FOOTER //
// ./scripts/main.js